const DETALING_STEP = 0
const COMMUNICATION_STEP = 1

const DETALING_ENUM = 'detaling'
const COMMUNICATION_ENUM = 'communication'

export default {
  DETALING_STEP,
  COMMUNICATION_STEP,
  DETALING_ENUM,
  COMMUNICATION_ENUM,
}
